import { TimePicker } from "antd";

import { TIME_FORMAT } from "./consts";
import { TimePickerFieldProps } from "./types";
import { useTimePickerField } from "./hooks";

const TimePickerField: React.FC<TimePickerFieldProps> = ({
  value,
  onChange,
  ...props
}) => {
  const field = useTimePickerField({ value, onChange });

  return <TimePicker format={TIME_FORMAT} {...props} {...field} />;
};

export default TimePickerField;
